// Ops demo API: answers every makeRequest call in demo mode from the
// in-memory data layer. Must not import helpers/http.helper, helpers/config,
// services or stores (those import this module).

import { defineRoutes, resolveWith, type DemoRequest, type DemoRoute } from '../core';
import { monitoringRoutes } from './monitoring.routes';
import { outletRoutes } from './outlet.routes';
import { platformRoutes } from './platform.routes';
import { recyclerRoutes } from './recycler.routes';

// Monitoring first: '/pickup_order/ops/...' and '/pickup_order/fleet/...' are more specific
// than the outlet's '/pickup_order/:orderId' family.
export const routes: DemoRoute[] = defineRoutes([...monitoringRoutes, ...platformRoutes, ...outletRoutes, ...recyclerRoutes]);

export function resolveDemoRequest(req: DemoRequest): Promise<unknown> {
  return resolveWith(routes, req);
}
